import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Stick from "../../components/charts/stick";

export default function StylistDetailDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const log = location.state?.log || null;
  const data_index = location.state?.index || 0;
  const stylistId = location.state?.stylistId || null;
  const stylistName = location.state?.stylistName || null;
  const locationId = location.state?.locationId || null;
  const locationName = location.state?.locationName || null;
  const colors = ["#ed0f7e", "#0dcae7", "#6ee60b"];

  useEffect(() => {
    const content = document.getElementsByClassName(
      "dx-drawer-panel-content"
    )[0];
    content.style.display = "none";
    return () => {
      content.style.display = "block";
    };
  }, []);

  return (
    <>
      <h2 className={"content-block"}>
        {stylistName ? `Clients - ${stylistName}` : "Clients"}
      </h2>
      <div className={"responsive-paddings"}>
        <Grid container>
          {log ? (
            <Grid item lg={4} md={6} xs={12}>
              <Stick
                color={colors[data_index]}
                data={log}
                onClick={() =>
                  navigate("/rolled-reports-sql", {
                    state: {
                      clientName: log.client,
                      stylistId,
                      stylistName,
                      locationId,
                      location_name: locationName,
                    },
                  })
                }
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <h5>No data</h5>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
}
